import { api, generateCRUDInterface } from "aldoo-ra/API"

const crudAPI   = api("crud")
const adminAPI  = api("agent-admin")

// ── CRUD interfaces ───────────────────────────────────────────────────────────
export const AgentsCRUD = generateCRUDInterface(crudAPI, "AaAgent")
export const SessionsCRUD  = generateCRUDInterface(crudAPI, "AaSalesAgentSession")
export const UsagesCRUD    = generateCRUDInterface(crudAPI, "AaModelUsage")
export const NeedsCRUD     = generateCRUDInterface(crudAPI, "AaSalesAgentNeed")
export const VisitorsCRUD  = generateCRUDInterface(crudAPI, "AaSalesAgentVisitor")

// ── Custom (aggregations + registry) ─────────────────────────────────────────
export const GetRegistry      = ()       => adminAPI({ get_registry: {} })
export const GetUsagesStats   = (params) => adminAPI({ get_usages_stats: params || {} })
export const GetNeedsStats    = (params) => adminAPI({ get_needs_stats: params || {} })
export const GetVisitorsStats = ()       => adminAPI({ get_visitors_stats: {} })
